import { render, staticRenderFns } from "./addWorkList.vue?vue&type=template&id=5253f73e&scoped=true"
import script from "./addWorkList.vue?vue&type=script&lang=js"
export * from "./addWorkList.vue?vue&type=script&lang=js"
import style0 from "./addWorkList.vue?vue&type=style&index=0&id=5253f73e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253f73e",
  null
  
)

export default component.exports